export default "__VITE_ASSET__Dg7L2DsC__"